export default {
    state: {
        //deliver a point to custome road map shown at top of page
        customeRoadMap:null
    },
    mutations: {
        setRoadMap(state,data){
            state.customeRoadMap = data;
        }
    },
    getters:{
        customeRoadMap(state){
            return state.customeRoadMap;
        }
    },
    actions: {
        setRoadMap({commit},data){
            commit('setRoadMap',data);
        },

        setCourseOfTeacher({commit},data){
            commit('setCourseOfTeacher',data);
        },

        setCourseOfStudent({commit},data){
            commit('setCourseOfStudent',data);
        }
    }
};
